import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import DefaultButton from '../../../../../../global/default-button/default-button';
import { CommonModal } from '../../../../../../global/modal/common/common-modal';
import { CodeEditor } from '../../../../../../global/code-editor/code-editor';
import { CANCEL_TEXT, DONE_TEXT } from '../../../../../../../constants/common-labels.constants';
import {
    CODE_EDITOR_HEIGHT,
} from '../../../../../../_events/_manage-event/_edit-website/website-form-body/custom-css-form/constants/custom-css.constants';
import { EditHubVM } from '../edit-hub.viewmodel';
import './edit-custom-css-modal.scss';
import { CUSTOM_CSS_LABEL_TEXT, EDIT_CUSTOM_CSS_TEXT } from '../../../../../event-hubs.text';

type EditCustomCssModalProps = {
    vm: EditHubVM;
};

export const EditCustomCssModal: React.FC<EditCustomCssModalProps> = observer(({ vm }) => (
    <CommonModal
        isOpen
        isWide
        onRequestClose={vm.closeCustomCssEditor}
        className='edit-custom-css-modal'
        classNameBody='edit-custom-css-modal__body-wrapper'
        title={<FormattedMessage {...EDIT_CUSTOM_CSS_TEXT} />}
        footer={
            <div className='edit-custom-css-modal__footer'>
                <DefaultButton
                    modifier='cancel'
                    text={<FormattedMessage {...CANCEL_TEXT} />}
                    onClick={vm.closeCustomCssEditor}
                />
                <DefaultButton
                    text={<FormattedMessage {...DONE_TEXT} />}
                    onClick={vm.applyCustomCssEditor}
                    disabled={!!vm.getCustomCssDraftValidationError()}
                />
            </div>
        }
    >
        <div className='edit-custom-css-modal__body'>
            <CodeEditor
                label={<FormattedMessage {...CUSTOM_CSS_LABEL_TEXT} />}
                height={CODE_EDITOR_HEIGHT}
                value={vm.getCustomCssDraft()}
                onChange={value => vm.setCustomCssDraft(value)}
                validationError={vm.getCustomCssDraftValidationError() ?? undefined}
            />
        </div>
    </CommonModal>
));
